import { changeCustomerSelectCustomerContainerStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { css } from "styled-components";

changeCustomerSelectCustomerContainerStyles.billToSelector = {
    billToSelectorDynamicDropdown: {
        cssOverrides: {
            list: css`
                background: #ffffff;
            `,
        },
    },
};
changeCustomerSelectCustomerContainerStyles.shipToSelector = {
    shipToSelectorDynamicDropdown: {
        cssOverrides: {
            list: css`
                background: #ffffff;
            `,
        },
    },
};
changeCustomerSelectCustomerContainerStyles.cancelButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        margin-right: 15px;
    `,
};
